import { Button, Icons, Stack, tokens } from '@cast/design-system';

import { useAutoOptimization } from '../../_hooks/useAutoOptimization';

type WizardBottomBarProps = {
  nextButtonLabel: string;
};

export const WizardBottomBar = ({ nextButtonLabel }: WizardBottomBarProps) => {
  const { onBack, backButtonStatus, onNext, nextButtonStatus } =
    useAutoOptimization();

  if (nextButtonStatus === 'hidden') {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      sx={{
        bgcolor: tokens.theme.bg.structural.surfaceSubtle,
        borderTop: '1px solid',
        borderColor: tokens.theme.border.structural.neutral,
        px: 32,
        py: 16,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ maxWidth: 800, width: '100%' }}
      >
        {backButtonStatus !== 'hidden' ? (
          <Button
            variant="secondary"
            size="md"
            startIcon={<Icons.ArrowLeft />}
            onClick={onBack}
            disabled={backButtonStatus === 'disabled'}
          >
            Back
          </Button>
        ) : (
          <span />
        )}
        <Button
          variant="primary"
          size="md"
          endIcon={<Icons.ArrowRight />}
          disabled={nextButtonStatus === 'disabled'}
          onClick={onNext}
          testId="wizard-next-btn"
        >
          {nextButtonLabel}
        </Button>
      </Stack>
    </Stack>
  );
};
